import event from "../util/NotifierManager";
import { deserialize } from '../util/util';
import { EVENT_SWITCH_VIEW } from "../util/constant";
import { updateViewI18n } from "../i18n";

export default class View {
    constructor(view) {
        this.url = '';
        this.key = '';
        this.active = false;
        this.view = view;
        this.dm = view.dm();

        event.add(EVENT_SWITCH_VIEW, (key) => {
            this.handleSwitch(key);
        });
    }

    handleSwitch(key) {
        if (key === this.key) {
            if (!this.active) {
                this.active = true;
                this.onSetup();
            }
            this.dm.clear();
            deserialize(this.view, this.url, this._onPostDeserialize.bind(this));
        }
        // 目前是这个场景，执行 tearDown
        else if (this.active) {
            this.onTearDown();
            this.active = false;
        }

    }
    /**
     * 默认调用国际化更新，若需反序列化处理可重载 onPostDeserialize
     * @param json 
     * @param dm 
     * @param view 
     * @param list 
     */
    _onPostDeserialize(json, dm, view, list) {
        this.onPostDeserialize(json, dm, view, list);
        this.updateI18n();
        this.handleLocaleChange();
    }
    /**
     * 加载这个场景前调用
     */
    onSetup() {
        this.view.mi(this.handleInteractive, this);
        this.view.mp(this.handlePropertyChange, this);
    }
    /**
     * 离开这个场景时会调用
     */
    onTearDown() {
        this.view.umi(this.handleInteractive, this);
        this.view.ump(this.handlePropertyChange, this);
    }
    /**
     * 加载完场景处理
     */
    onPostDeserialize(json, dm, view, list) {

    }
    /**
     * 有需要交互重写此方法
     */
    handleInteractive(e) { }

    /**
     * 监听视图组件属性变化
     */
    handlePropertyChange(e) { }

    /**
     * 当国际化更新时，执行此方法，需要其他逻辑可重载
     */
    handleLocaleChange() {

    }

    /**
     * 更新所有国际化绑定
     */
    updateI18n() {
        updateViewI18n(this.view);
    }
}

